export default "__VITE_ASSET__502cfa2f__"